import React, { useEffect, useState } from "react";
import useRecordingDataSession from "../customeHooks/useRecordingDataSession";
import useCoreAgoraRecording from "../../../general/customHooks/coreAgoraRecording";
import VideoPlayer from "../../../general/components/VideoUser/VideoPlayer";
import { checkVoulumeLevel } from "../../../general/functions/agoraCustomeFunctions";
import { classNames } from "../../../general/functions/propsComponent";
import useInfoAssessorLeave from "../../SessionMethodVideoModul/customeHooks/useInfoAssessorLeave";

export default function RecordingUI() {
  console.log("Recording UIcall");
  const [listUserData, setListUserData] = useState([]);

  const { selfUid, tokenAgora, session, listUser, dataSession } =
    useRecordingDataSession();
  // console.log(
  //   " Recording UIcall useDataSession",
  //   selfUid,
  //   session,
  //   dataSession,
  //   listUser
  // );
  const { usersJoin, usersVolume, isConnect, setJoin, errorInfo } =
    useCoreAgoraRecording({
      uid: parseInt(selfUid),
      channelName: session,
      token: tokenAgora,
    });
  useInfoAssessorLeave({ listUserData: listUserData });

  useEffect(() => {
    setJoin(true);
  }, []);
  useEffect(() => {
    let tmp = listUser?.map((x) => {
      let dTmp = usersJoin.find((y) => y.uid == x.uId);

      if (dTmp != undefined) {
        x.agora = dTmp;
      } else {
        x.agora = null;
      }
      return x;
    });

    console.log("tmp", tmp, listUser, usersJoin);

    setListUserData(tmp);
  }, [usersJoin, listUser]);

  let screenShareAvailable =
    listUserData?.find((x) => x.type == "SHARESCREEN")?.agora?.agoraDetail !=
    null;
  let listUserView = listUserData
    ?.sort((a, b) => {
      let na = 0;
      let nb = 0;
      if (a?.isMuteTrackSelf?.video) {
        na += 1;
      }
      if (a?.isMuteTrackSelf?.audio) {
        na += 2;
      }
      if (b?.isMuteTrackSelf?.video) {
        nb += 1;
      }
      if (b?.isMuteTrackSelf?.audio) {
        nb += 2;
      }
      if (na > nb) {
        return 1;
      }
      if (na < nb) {
        return -1;
      }
    })
    ?.filter(
      (x) =>
        x.type != "SHARESCREEN" && x.type != "RECORDING" && x?.agora != null
    );
  let positionVideoList =
    listUserData?.filter((x) => x.type != "RECORDING" && x?.agora != null)
      .length >= 4;
  // console.log("listUserView", listUserView, listUserData);
  return (
    <>
      <div
        className=" h-full flex w-full overflow-hidden "
        style={{ height: "92vh", maxWidth: "100vw", minHeight: "720px" }}
      >
        <div className={classNames("w-full h-full  mx-auto  ")}>
          <div className="text-white  p-2 flex flex-col justify-start items-start">
            <h1 className="text-lg font-medium">
              {dataSession.sessionInfo?.sessionTitle}
            </h1>
            <p>Record Mode</p>
          </div>
          {screenShareAvailable ? (
            <div
              className=" flex justify-center items-center pt-4  w-full"
              style={{
                height: screenShareAvailable ? "50%" : "0%",
              }}
            >
              <div
                className="aspect-video  flex  items-center justify-center "
                style={{ width: "100%", maxHeight: "100%" }}
              >
                <VideoShareScreen
                  shareScreen={listUserData.find(
                    (x) => x.type == "SHARESCREEN"
                  )}
                  usersVolume={usersVolume}
                />
              </div>
            </div>
          ) : (
            <div
              className={classNames(
                " flex gap-2 mt-2  overflow-auto p-2 ",
                positionVideoList ? "" : "justify-center"
              )}
              style={{
                height: "0%",
                width: "100%",
              }}
            >
              {/* {isConnect && (
                <VideoMain
                  users={listUserView}
                  usersVolume={usersVolume}
                  isShareScreen={screenShareAvailable}
                />
              )} */}
            </div>
          )}
          {/* <p className="text-white">asdsd {isConnect.toString()}</p> */}
          <div
            className={classNames(
              " flex gap-2 mt-2  overflow-auto p-2 ",
              positionVideoList ? "" : "justify-center"
            )}
            style={{
              height: screenShareAvailable ? "50%" : "auto",
              width: "100%",
            }}
          >
            {isConnect && (
              <VideoList
                users={listUserView}
                usersVolume={usersVolume}
                isShareScreen={screenShareAvailable}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const VideoShareScreen = (props) => {
  const { shareScreen } = props;
  let videoMain = shareScreen?.agora?.agoraDetail != null ? shareScreen : null;
  console.log("videoMain", videoMain);
  return (
    <>
      {videoMain != null && (
        <div
          className="relative h-full p-0  border border-secondary-300 aspect-video "
          style={{}}
        >
          <VideoPlayer
            videoTrack={videoMain?.agora?.agoraDetail.videoTrack}
            isVideoMute={!videoMain?.agora?.video}
            isMicMute={!videoMain?.agora?.audio}
            title={videoMain?.name}
            uid={videoMain?.uId}
            shareScreen={shareScreen?.agora?.agoraDetail != null ? true : false}
            isSpeak={false}
          />
        </div>
      )}
    </>
  );
};

const VideoMain = (props) => {
  const { users, usersVolume } = props;
  let userShow = Array.isArray(users) ? users[0] : {};
  return (
    <>
      <div
        className="flex gap-1 flex-nowrap bg-red-50 "
        style={{ height: "100%" }}
      >
        {userShow?.agora != null && (
          <VideoPlayer
            videoTrack={userShow?.agora?.agoraDetail?.videoTrack}
            isVideoMute={!userShow?.agora?.video}
            isMicMute={!userShow?.agora?.audio}
            title={userShow?.name}
            uid={userShow?.uId}
            tagLable={userShow?.type == "ASSESSOR" ? userShow?.type : null}
            isSpeak={checkVoulumeLevel(usersVolume, userShow?.uId).status}
          />
        )}
      </div>
    </>
  );
};

const getGridCols = (c, isShareScreen) => {
  if (isShareScreen == true) {
    return "grid-cols-6";
  } else {
    if (c <= 2) {
      return "grid-cols-2";
    } else if (c <= 6) {
      return "grid-cols-3";
    } else if (c <= 12) {
      return "grid-cols-4";
    } else if (c <= 20) {
      return "grid-cols-5";
    } else {
      return "grid-cols-6";
    }
  }
};

const VideoList = (props) => {
  const { users, usersVolume, isShareScreen } = props;
  let userJoinCount = users.length;

  return (
    <>
      <div
        className={classNames(
          "grid bg-black w-full",
          getGridCols(userJoinCount, isShareScreen)
        )}
        style={{}}
      >
        {users?.map((x, i) => {
          // sharescrin off withoud 1, on with 1
          return (
            <>
              <div className="aspect-video">
                <VideoPlayer
                  videoTrack={x.agora?.agoraDetail?.videoTrack}
                  isVideoMute={!x.agora?.video}
                  isMicMute={!x.agora?.audio}
                  title={x?.name}
                  uid={x?.uId}
                  tagLable={x?.type == "ASSESSOR" ? x?.type : null}
                  isSpeak={checkVoulumeLevel(usersVolume, x?.uId).status}
                />
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};
